import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class LogicParameter extends DesigntimeComponent {
    static staticName = "Logic: Parameter";
    static staticId = "logicParameter";
    hasRuntimeView = false;

    constructor(identifyer) {
        super(identifyer, 1);
        this.values = {
            number: { value: 100 }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("readyToShowEvent", this.fireParam.bind(this))
        return $("<div class='logicParameter'></div>");
    }

    fireParam() {
        this.eventBroker.fireValueChanged(this.id, "parameter", this.values.number.value);
    }

    output = [{ name: "parameter", type: "number" }]
}

export { LogicParameter }
